import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import ContentBlock from '../../components/contentBlock/contentBlock';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import Image from '../../components/image/image';
import Wistia from '../../components/wistiaVideo/wistiaVideo';
import { generateSlug } from '../../lib/functions/util-functions';
import cta_wistia_video from '../cta/wistia_cta.scss';

/**
 * 
 * Cms: ModuleCTASideBySideFragment
 * 
 * 3 main Variations: Left/Right, Icon, Background
 * 
 * 
 */
const CTA = ({ data, className, ...other }) => {
  let { anchor, border, colorProfile, ctaContent, ctaType, image, overrideButtonStyles, textPosition, wistiaId } = data || {};
  colorProfile = ctaType === 'Icon' ? 'Reversed' : colorProfile;

  const isWistiaOnly = wistiaId && !image;

  return (
    
    <ModuleWrapper anchor={anchor} border={border} className={`cta ${className || ''} ${colorProfile || 'Default'} ${textPosition || ''} cta--${generateSlug(ctaType)}`} {...other}>
      <div className={isWistiaOnly ? "cta_wistia_video" : "cta__media_image"} aria-hidden="true">
        {wistiaId ? (
          <Wistia id={wistiaId} controls={false} quality="1080" allow="autoplay" muted="true" loop="true" videoType="Background" />
        ) : (
          <Image data={image} />
        )}
      </div>

      {!isWistiaOnly && ctaContent && <ContentBlock data={ctaContent[0]} className={`${colorProfile || 'Default'} ${overrideButtonStyles || ''}`} />}

      {image && ctaType === 'Icon' && (
        <div className="cta__media_image" aria-hidden="true">
          <Image data={image} width={230} />
        </div>
      )}
    </ModuleWrapper>
  );
};

CTA.propTypes = {
  data: PropTypes.shape({
    anchor: PropTypes.string,
    border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),
    colorProfile: PropTypes.oneOf(['Default', 'Reversed']),
    ctaContent: PropTypes.array,
    ctaType: PropTypes.oneOf(['Centered', 'Left', 'Icon', 'Primary Framed Image', 'Secondary Framed Image', 'Primary Fade Image', 'Secondary Fade Image']),
    image: PropTypes.object,
    socialLinks: PropTypes.object,
    textPosition: PropTypes.oneOf(['Left', 'Right']),
    wistiaId: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default CTA;


export const ModuleCTASideBySideFragment = graphql`
  fragment ModuleCTASideBySideFragment on DatoCmsModuleCtaSideBySide {
     
    anchor
    toggleId
    border
    colorProfile
    ctaContent{
      ...EyebrowHeadingCopyLinkFragment
    }
    ctaType
    image{
      ...ContainerImageFragment
    }
    textPosition
    wistiaId
  }`;

  export const ModuleCTAOverlayFragment = graphql`
  fragment ModuleCTAOverlayFragment on DatoCmsModuleCtaOverlay {
     
    anchor
    toggleId
    border
    colorProfile
    ctaContent{
      ...HeadingCopyLinkFragment
    }
    ctaType
    image{
      ...BackgroundImageFragment
    }
    overrideButtonStyles
    wistiaId
    toggleId
  }`;